// Allocates LanguageUseScheme.displayNumber values — small, per-exam-unique numbers teachers/chat can
// reference a group by ("Gruppe 3") instead of its opaque _id. Decoupled from _id on purpose: _id is a
// permanent foreign key (languageUseRuleResults, gradingProgress.finishedUnits) and must never be reused,
// whereas displayNumber only needs to be memorable and unique — see Exam.languageUseSchemeSeq's own doc.

import { getCollection } from '@adornis/baseql/server/collections.js';
import { Exam } from '../../exam.js';

/**
 * Reserves `count` consecutive, never-before-used display numbers for this exam in one atomic `$inc` —
 * safe under concurrent creation (no read-then-write race), and numbers are never reused even if every
 * group that ever held them is later deleted.
 */
export async function allocateLanguageUseSchemeDisplayNumbers(examId: string, count: number): Promise<number[]> {
  if (count <= 0) return [];

  const examCollection = await getCollection(Exam);
  const updated = await examCollection.findOneAndUpdate(
    { _id: examId } as any,
    { $inc: { languageUseSchemeSeq: count } } as any,
    { returnDocument: 'after' },
  );

  const last = Number((updated as any)?.languageUseSchemeSeq ?? count);
  const first = last - count + 1;
  return Array.from({ length: count }, (_, i) => first + i);
}
